import {
  CopyStyle,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "components/lib";
import React from "react";

const StudioDialog = ({ closeDialog, openModal }) => {
  const styleItems = [
    { inputValue: "https://api.mapmetrics.org/styles", text: "Preview" },
    { inputValue: "https://api.mapmetrics.org/styles", text: "Allow Copying" },
    { inputValue: "https://api.mapmetrics.org/styles", text: "Website embed" },
  ];
  const webItems = [
    { inputValue: "https://api.mapmetrics.org/styles", text: "Style URL" },
    { inputValue: "https://api.mapmetrics.org/styles", text: "Access token" },
    { inputValue: "MapName.zip", text: "Download" },
  ];
  const tabs = [
    { name: "Web" },
    { name: "Android" },
    { name: "iOS" },
    { name: "Third Party" },
  ];
  return (
    <React.Fragment>
      <div
        className={`fixed  overflow-y-auto top-0 right-0 bottom-0 left-0 ${
          openModal ? "block z-[1072]" : "hidden z-[1050]"
        }`}
        onClick={closeDialog}
      >
        <div
          className={`sm:max-w-lg sm:w-full my-4 mx-auto relative transition-transform transform duration-300 ease-out ${
            openModal ? "translate-y-0" : "-translate-y-[25%]"
          } `}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="dark:bg-slate-800 bg-white px-4 pt-5 pb-10 rounded-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-5">
              <h5 className="text-[20px] text-primary dark:text-white font-semibold">
                keys
              </h5>
              <span className="cursor-pointer" onClick={closeDialog}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                >
                  <circle
                    opacity="0.05"
                    cx="20"
                    cy="20"
                    r="20"
                    fill="#E71D36"
                  />
                  <path
                    opacity="0.8"
                    d="M20.9161 19.9999L24.8099 23.8939C25.0634 24.1472 25.0634 24.5567 24.8099 24.81C24.5567 25.0633 24.1471 25.0633 23.8939 24.81L19.9999 20.916L16.1061 24.81C15.8527 25.0633 15.4433 25.0633 15.1901 24.81C14.9366 24.5567 14.9366 24.1472 15.1901 23.8939L19.0839 19.9999L15.1901 16.1059C14.9366 15.8526 14.9366 15.4431 15.1901 15.1898C15.3163 15.0635 15.4822 15 15.6481 15C15.8139 15 15.9798 15.0635 16.1061 15.1898L19.9999 19.0838L23.8939 15.1898C24.0202 15.0635 24.1861 15 24.3519 15C24.5178 15 24.6836 15.0635 24.8099 15.1898C25.0634 15.4431 25.0634 15.8526 24.8099 16.1059L20.9161 19.9999Z"
                    fill="#E71D36"
                  />
                </svg>
              </span>
            </div>
            <p className="text-black leading-normal text-[14px]">
              Use the URLs to share your map or seamlessly integrate your
              customized map into your projects and applications. When updated,
              it may take a few minutes for changes to fully reflect.
            </p>
            <div className="py-5">
              <h5 className="text-[16px] text-primary dark:text-white font-semibold">
                Style
              </h5>
            </div>
            <CopyStyle items={styleItems} />
            <div className="py-5">
              <h5 className="text-[16px] text-primary dark:text-white font-semibold">
                Developer
              </h5>
              <Tabs defaultValue="Web" className="mt-5">
                <div className="flex justify-center">
                  <TabsList className="inline-flex justify-center mx-auto mb-10">
                    {tabs.map((tab, i) => (
                      <TabsTrigger
                        className="px-2 py-3 rounded-[10px] text-[#FF8F6B]"
                        key={i}
                        value={tab.name}
                      >
                        {tab.name}
                      </TabsTrigger>
                    ))}
                  </TabsList>
                </div>
                <TabsContent value="Web">
                  <CopyStyle items={webItems} />
                </TabsContent>
                <TabsContent value="Android">
                  <CopyStyle items={webItems} />
                </TabsContent>
                <TabsContent value="iOS">
                  <CopyStyle items={webItems} />
                </TabsContent>
                <TabsContent value="Third Party">
                  <CopyStyle items={webItems} />
                </TabsContent>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
      {openModal && (
        <div className="fixed left-0 top-0 bottom-0 right-0 bg-gray-900 opacity-75 z-[1071]"></div>
      )}
    </React.Fragment>
  );
};

export default StudioDialog;
